import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Box,
    Typography,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@material-ui/core';
import AlertBox from '../../AlertBox';
import { useDispatch } from 'react-redux';
import { startLoader, stopLoader } from "../../../actions/loaderActions";
import config from "../../../config";
import { useHistory } from 'react-router-dom';

const ApiBaseUrl = config.NodeApiBaseUrl;

const getDefaultHeaders = () => ({
    "x-tenant-schema": "Amplo111",
    "x-user-id": localStorage.getItem("UserId") || ""
});

const DashboardTab = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [summary, setSummary] = useState([]);
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'error' });

    const fetchDashboardSummary = async () => {
        dispatch(startLoader());

        try {
            const response = await axios.get(`${ApiBaseUrl}category/dashboard-summary`, {
                headers: getDefaultHeaders(),
            });
            setSummary(response.data || []);
        } catch (err) {
            console.error('Dashboard summary fetch failed:', err);
            setAlert({
                open: true,
                message: 'Failed to fetch dashboard summary',
                severity: 'error'
            });
        }

        dispatch(stopLoader());
    };

    useEffect(() => {
        fetchDashboardSummary();
    }, []);

    const redirectToDataCategory = () => {
        history.push('/data-management/dataCategory');
    };

    return (
        <Box p={3}>

            <Paper style={{ marginTop: 16, padding: 8 }}>
                <Table>
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#3c4246' }}>
                            <TableCell style={{ color: 'white' }}><b>Framework</b></TableCell>
                            <TableCell style={{ color: 'white' }}><b>Industry Count</b></TableCell>
                            <TableCell style={{ color: 'white' }}><b>Category Count</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {summary.length > 0 ? (
                            summary.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell>{row.framework}</TableCell>

                                    <TableCell
                                        onClick={redirectToDataCategory}
                                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                    >
                                        {row.industry_count}
                                    </TableCell>

                                    <TableCell
                                        onClick={redirectToDataCategory}
                                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                    >
                                        {row.category_count}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    No data available
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>

            <AlertBox
                open={alert.open}
                onClose={() => setAlert({ ...alert, open: false })}
                message={alert.message}
                severity={alert.severity}
            />
        </Box>
    );
};

export default DashboardTab;
